// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Attachments from '@/components/shared-views/attachments';
import ItemComments from '@/components/shared-views/item-comments';
import ToastContext from '@/utils/toast-context';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import AuditLog from '@/components/shared-views/audit-log';
import IntegrationService from '@/services/integration-service';
import InventoryItemForm from "@/PageComponents/Inventory/InventoryItemForm";
import { Box, Button, Card, Flex, Tooltip, Text } from "@mantine/core";
import { useElementSize } from "@mantine/hooks";
import ToolbarButtons from "@/PageComponents/Button/ToolbarButtons";
import { IconArrowBackUp, IconDeviceFloppy, IconSend } from "@tabler/icons-react";
import AlertIcon from "@/PageComponents/Icons/AlertIcon";

function ManageInventory({ isNew, manageInventory, inventoryCategory, inventorySubcategory, accessStatus }: any) {

    /*const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
    const [showCreateSubcategoryModal, setShowCreateSubcategoryModal] = useState(false);
    const [showCreateSupplierModal, setShowCreateSupplierModal] = useState(false);*/

    const [inventory, setInventory] = useState(isNew ? {
        Code: '',
        Description: '',
        WarrantyPeriod: 0,
        WebForm: false,
        Quantity: 0,
        CostPrice: 0,
        ListPrice: 0,
        CommissionPercentage: 0,
        BinLocation: '',
        IsActive: true,
    } : manageInventory);

    /*const [formIsDirty, setFormIsDirty] = useState(false);
    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());*/


    // const [inputErrors, setInputErrors] = useState<any>({});

    const toast = useContext(ToastContext);


    useEffect(() => {
        if (!isNew) {
            getCounts();
            //getSubcategory();
            // getSupplier();
            // getStockItemType();
            // fetchComments();
            getIntegration();
        }
    }, []);

    // CATEGORIES

    // const [selectedCategory, setSelectedCategory] = useState(inventoryCategory ? inventoryCategory : undefined);

    // SUBCATEGORIES

    // const [selectedSubcategory, setSelectedSubcategory] = useState(inventorySubcategory ? inventorySubcategory : undefined);


    // STOCK ITEM TYPE

    // const [selectedStockItemType, setSelectedStockItemType] = useState<any>();


    // SUPPLIER

    // const [selectedSupplier, setSelectedSupplier] = useState<any>();


    // COMMENTS  

    // const [comments, setComments] = useState<any[]>([]);
    // const [commentsPage, setCommentsPage] = useState(0);
    // const [canLoadMoreComments, setCanLoadMoreComments] = useState(false);

    // };

    // };

    // const [newComment, setNewComment] = useState('');

    //     if (newComment.length != 0) {
    //         url: '/Comment',
    //         params: {
    //             ItemID: inventory.ID,
    //             CommentText: newComment,
    //             Module: Enums.Module.Inventory,
    //         fetchComments();
    // };

    // const [submittingComment, setSubmittingComment] = useState(false);

    //     if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
    //         return;
    //     submitComment();
    // };

    //     url: '/Comment/GetComments',
    //     params: {
    //             ItemId: inventory.ID,
    //             PageIndex: page ? page : 0,
    //             PageSize: 5

    //     if (currentComments) {
    //         if (page != commentsPage) {
    //             newComments.push(...currentComments);

    //     newComments.push(...request.Results);

    //     if (request.ReturnedResults < 5) {
    //     } else if (newComments.length == request.TotalResults) {
    //     } else {
    // };

    // INTEGRATION

    const [integration, setIntegration] = useState<any>();
    const [integrationTooltip, setIntegrationTooltip] = useState('');

    const getIntegration = async () => {
        let integration = await IntegrationService.getIntegration();
        if (integration) {
            setIntegrationTooltip((integration as any).Status == Enums.IntegrationStatus.Live ? ''
                : `Inventory on ${Enums.getEnumStringValue(Enums.IntegrationPartner, (integration as any)?.Partner)} has status of ${Enums.getEnumStringValue(Enums.IntegrationStatus, (integration as any).Status)}`);
        }
        setIntegration(integration);
    };

    const syncInventory = async () => {
        const result = await Fetch.post({
            url: `/Inventory/InventorySync?inventoryID=${inventory.ID}`,
            toastCtx: toast
        });
        if (result.ID) {
            toast.setToast!!!({
                message: 'Inventory successfully queued for sync',
                show: true,
                type: 'success'
            });
            setInventory(result);
        } else {
            toast.setToast!!!({
                message: 'Inventory failed to sync',
                show: true,
                type: Enums.ToastType.error
            });
        }
    };

    const [attachmentCount, setAttachmentCount] = useState(0);
    const [countsToggle, setCountsToggle] = useState(false);

    const getCounts = async () => {
        let countRequest = await Fetch.get({
            url: `/Inventory/GetCounts?id=${inventory.ID}`,
        });
        let result = countRequest.Results;
        setAttachmentCount(result.find((x: any) => x.Key == 'Attachments').Value);

        setCountsToggle(!countsToggle);
    };

    useEffect(() => {
        buildUpPageTabs();
    }, [countsToggle]);

    const onAttachmentRefresh = () => {
        getCounts();
    };

    const [pageTabs, setPageTabs] = useState<any[]>([]);
    const [selectedTab, setSelectedTab] = useState('Inventory');


    const trySetSelectedTab = (tab: any) => {
        // form state is no longer handled here and changing tabs will not trigger confirm - to solve the issue use routing for tabs

        setSelectedTab(tab);

    };

    const buildUpPageTabs = () => {
        let tabs = [
            { text: 'Inventory' },
            { text: 'Attachments', count: attachmentCount },
        ];
        setPageTabs(tabs);
    };

    const onImageUploaded = async () => {
        if (!isNew) {
            await getCounts();
        }
    }

    /*const validate = () => {

        let validationItems = [];
        validationItems = [
            { key: 'Description', value: inventory.Description, required: true, type: Enums.ControlType.Text },
            { key: 'InventoryCategory', value: selectedCategory, required: true, type: Enums.ControlType.Select },
            { key: 'InventorySubcategory', value: selectedSubcategory, required: true, type: Enums.ControlType.Select },
            { key: 'StockItemType', value: selectedStockItemType, required: true, type: Enums.ControlType.Select },
            { key: 'CostPrice', value: inventory.CostPrice, required: true, type: Enums.ControlType.Number },
            { key: 'ListPrice', value: inventory.ListPrice, required: true, type: Enums.ControlType.Number },
            { key: 'CommissionPercentage', value: inventory.CommissionPercentage, required: true, btw: [0, 100], type: Enums.ControlType.Number },
            { key: 'Quantity', value: inventory.Quantity, required: true, type: Enums.ControlType.Number },
            { key: 'WarrantyPeriod', value: inventory.WarrantyPeriod, required: true, gte: 0, type: Enums.ControlType.Number },
        ];

        const { isValid, errors } = Helper.validateInputs(validationItems);
        setInputErrors(errors);
        return isValid;
    };*/

    const [saving, setSaving] = useState(false);
    const [auditToggle, setAuditToggle] = useState(true);

    const [saveTrigger, setSaveTrigger] = useState(0)

    async function saveInventory() {
        setSaving(true)
        setSaveTrigger((p: any) => p + 1)


    }

    const router = useRouter();

    const cancel = () => {
        Helper.nextRouter(router.push, '/inventory/list?tab=inventory');
    };

    const { height: toolbarHeight, ref: toolbarRef } = useElementSize()

    return (
        <>
            <Box bg={'white'} ref={toolbarRef} pb={isNew ? 'sm' : 0}>
                <Flex justify={'apart'} w={'100%'} mt={'15px'} gap={'sm'} px={10} >
                    <Flex align={'center'} >
                        {isNew ?
                            <Breadcrumbs currPage={{ text: 'Create Inventory', link: '/inventory/create', type: 'create' }} /> :
                            <Breadcrumbs currPage={{ text: inventory.Code, link: `/inventory/${inventory.ID}` }} />
                        }
                    </Flex>

                    <ToolbarButtons
                        buttonGroups={[
                            ...(
                                !!integration && [
                                    [
                                        {
                                            show: inventory.InventorySyncStatus === Enums.SyncStatus.Pending,
                                            type: 'button',
                                            disabled: true,
                                            variant: 'default',
                                            text: `Sync pending to ${Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}`,
                                        },
                                        {
                                            show: inventory.InventorySyncStatus === Enums.SyncStatus.Synced,
                                            type: 'button',
                                            disabled: true,
                                            variant: 'default',
                                            text: `Synced`,
                                        },
                                        {
                                            show: inventory.InventorySyncStatus === Enums.SyncStatus.Deleted,
                                            type: 'button',
                                            disabled: true,
                                            variant: 'default',
                                            text: `Deleted`,
                                        },
                                        {
                                            show: inventory.IsActive && inventory.InventorySyncStatus === Enums.SyncStatus.Failed,
                                            type: 'custom',
                                            children: <Box>
                                                <Tooltip color={'yellow.7'} maw={300} multiline label={integrationTooltip} disabled={!integrationTooltip}
                                                    events={{ hover: true, focus: true, touch: true }}
                                                >
                                                    <Button
                                                        leftSection={<IconSend />}
                                                        rightSection={<Box style={{ cursor: 'help' }}>
                                                            <AlertIcon message={`${inventory.InventorySyncMessage}`} width={175} />
                                                        </Box>}
                                                        variant={'default'}
                                                        disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || integration.Status !== Enums.IntegrationStatus.Live}
                                                        onClick={() => syncInventory()}
                                                    >
                                                        Retry sync to {Enums.getEnumStringValue(Enums.IntegrationPartner, integration?.Partner)}
                                                    </Button>
                                                </Tooltip>
                                            </Box>
                                        }
                                    ]
                                ] || []
                            ),
                            ...(
                                !isNew && [
                                    [

                                        {
                                            breakpoint: 480,
                                            type: 'button',
                                            text: 'Cancel',
                                            hideIcon: true,
                                            variant: 'outline',
                                            icon: <IconArrowBackUp />,
                                            onClick: cancel,
                                        },
                                    ],
                                    [
                                        {
                                            breakpoint: 480,
                                            type: 'button',
                                            icon: <IconDeviceFloppy />,
                                            isBusy: saving,
                                            text: saving ? "Saving" : "Save",
                                            onClick: saving ? null : () => saveInventory(),
                                            disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess
                                        }
                                    ]
                                ] || []
                            )
                        ]
                        }
                    ></ToolbarButtons>

                </Flex>

                {
                    !isNew &&
                    <Tabs
                        selectedTab={selectedTab}
                        setSelectedTab={trySetSelectedTab}
                        tabs={pageTabs}
                        useNewTabs
                        tabsProps={
                            { mt: { base: 'sm', xxl: 0 }, mx: { base: 1, sm: 'xs', md: 'sm', lg: 'md' } }
                        }
                    />
                }

            </Box>
            {/*<div className="row">
                <div className="title">
                    {isNew ?
                        <Breadcrumbs currPage={{ text: 'Create Inventory', link: '/inventory/create', type: 'create' }} /> :
                        <Breadcrumbs currPage={{ text: inventory.Code, link: `/inventory/${inventory.ID}` }} />
                    }
                </div>
                {!isNew ? 
                    <div className="actions">
                        {integration ? 
                            inventory.InventorySyncStatus == Enums.SyncStatus.Pending ?
                                <Button disabled={true} text={`Sync pending to ${Enums.getEnumStringValue(Enums.IntegrationPartner, integration.Partner)}`} /> : 
                            inventory.InventorySyncStatus == Enums.SyncStatus.Synced ?
                                <Button disabled={true} text={`Synced`} /> : 
                            inventory.IsActive && inventory.InventorySyncStatus == Enums.SyncStatus.Failed ?
                                <>
                                    <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || integration.Status !== Enums.IntegrationStatus.Live}
                                        text={`Retry sync to ${Enums.getEnumStringValue(Enums.IntegrationPartner, integration.Partner)}`} icon="send" extraClasses="white-action"
                                        tooltip={integrationTooltip}
                                        onClick={() => syncInventory()} />
                                    <HelpDialog position="bottom" message={`${inventory.InventorySyncMessage}`} width={175} />
                                </> : '' : ''
                        }
                        <Button text="Cancel" extraClasses="hollow" onClick={cancel} />
                        <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                            text={saving ? "Saving" : "Save"} onClick={saving ? null : () => saveInventory()} />
                    </div>
                    : ''
                }
            </div>*/}

            {isNew ?
                <>
                    <Box
                        py={{ base: 5, xs: 8, sm: 'md' }}
                        px={{ base: 5, xs: 8 }}
                        mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
                    >
                        <Card
                            p={'md'}
                            px={{ base: 1, xs: 5, sm: 'sm' }}
                            radius={'md'}
                        >
                            <Box maw={1000}>
                                <InventoryItemForm
                                    isNew={isNew}
                                    onInventorySaved={
                                        (inventory: any) =>
                                            Helper.nextRouter(router.push, '/inventory/[id]', `/inventory/${inventory.ID}`)
                                    }
                                    onClose={cancel}
                                    accessStatus={accessStatus}
                                    onNewStatus={(s: any) => {
                                        setSaving(s === 'loading')
                                    }}
                                    triggerSaveCounter={saveTrigger}
                                    onImageUploaded={onImageUploaded}
                                />
                            </Box>
                        </Card>
                    </Box>
                    {/*{(() => {
                    return inventoryDetails();
                })()}*/}
                </>
                :
                <Box
                    bg={'gray.1'}
                    py={{ base: 5, xs: 8, sm: 'md' }}
                    px={{ base: 5, xs: 8 }}
                    mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
                >
                    <Card
                        p={'md'}
                        px={{ base: 1, xs: 5, sm: 'sm' }}
                        radius={'md'}
                    >
                        {(() => {
                            switch (selectedTab) {
                                case "Inventory":
                                    return <>
                                        {/*<Flex gap={'lg'} direction={{base: 'column', xl: 'row'}}>*/}
                                        <Flex gap={'lg'} direction={{ base: 'column' }}>
                                            <Box maw={1000} mt={'sm'} style={{ flexGrow: 1 }}>
                                                <InventoryItemForm
                                                    isNew={isNew}
                                                    inventory={inventory}
                                                    onInventorySaved={(inventory: any) => {
                                                        setInventory(inventory);
                                                        setAuditToggle((p: any) => !p);
                                                    }}
                                                    onClose={cancel}
                                                    accessStatus={accessStatus}
                                                    hideSaveAndCancel
                                                    onNewStatus={(s: any) => {
                                                        setSaving(s === 'loading')
                                                    }}
                                                    triggerSaveCounter={saveTrigger}
                                                    onImageUploaded={onImageUploaded}
                                                />
                                            </Box>


                                            <Box className="comments-and-history" style={{ flexGrow: 0 }} miw={600}>
                                                <ItemComments
                                                    itemID={manageInventory.ID}
                                                    module={Enums.Module.Inventory}
                                                    storeID={manageInventory.StoreID}
                                                />

                                                <AuditLog
                                                    recordID={inventory.ID}
                                                    retriggerSearch={auditToggle}
                                                    excludePropertyNames={
                                                        IntegrationService.canReceiveInventoryFromPartner(integration)
                                                            ? undefined
                                                            : ['Quantity']
                                                    }
                                                    propertyNameLabels={
                                                        IntegrationService.canReceiveInventoryFromPartner(integration)
                                                            ? { Quantity: 'Accounting Quantity' }
                                                            : undefined
                                                    }
                                                />
                                            </Box>
                                        </Flex>


                                        <hr />

                                    </>
                                case 'Attachments':
                                    return <Attachments displayName={inventory.Code} itemId={inventory.ID}
                                        module={Enums.Module.Inventory} onRefresh={onAttachmentRefresh}
                                        accessStatus={accessStatus} />;
                                default:
                                    return '';
                            }
                        })()}
                    </Card>
                </Box>
            }

            {/*<ConfirmAction options={confirmOptions} setOptions={setConfirmOptions}/>*/}

            <style jsx>{`
                .row {
                    display: flex;
                    justify-content: space-between;
                }

                .column {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                }

                .actions {
                    display: flex;
                }
                .actions :global(.button){
                    margin-left: 0.5rem;
                    margin-top: 0;
                    padding: 0 1rem;
                    white-space: nowrap;
                }
            `}
            </style>
        </>
    );
}

export default ManageInventory;
